import { lazy, Suspense } from 'react';
import Navigation from '@/components/Navigation';
import HeroSection from '@/components/HeroSection';
import ApartmentGallery from '@/components/ApartmentGallery';
import Footer from '@/components/Footer';

const ExperiencesSection = lazy(() => import('@/components/ExperiencesSection'));
const AboutSection = lazy(() => import('@/components/AboutSection'));
const TestimonialCarousel = lazy(() => import('@/components/TestimonialCarousel'));
const ContactForm = lazy(() => import('@/components/ContactForm'));
import CookieConsent from '@/components/CookieConsent';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main>
        <HeroSection />
        <ApartmentGallery />
        <Suspense fallback={null}>
          <ExperiencesSection />
          <AboutSection />
          <TestimonialCarousel />
          <ContactForm />
        </Suspense>
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default Index;
